import React from "react";
import { Grid } from "@mui/material";
import FormField from "layouts/pages/account/components/FormField";
import SettingsCard from "./SettingsCard";

const FooterContentSection = ({ inputData }) => {
  return (
    <SettingsCard
      title="Footer Content"
      subtitle="Configure footer information"
      gridProps={{
        xs: 12,
        sx: {
          "@media (min-width: 1100px)": {
            flexBasis: "calc(50% - 12px)",
            maxWidth: "calc(50% - 12px)",
            width: "calc(50% - 12px)"
          }
        }
      }}
    >
      <Grid container spacing={2.5}>
        <Grid item xs={12}>
          <FormField
            label="Address"
            name="address"
            defaultValue={inputData?.address || "123 Main St., Anytown, USA"}
          />
        </Grid>
        <Grid item xs={12}>
          <FormField
            label="Copyright"
            name="copyright"
            defaultValue={inputData?.copyright || "© 2025"}
          />
        </Grid>
      </Grid>
    </SettingsCard>
  );
};

export default FooterContentSection;
